<template>
  <div class="container">
    <div v-if="guide.profile && plans.length > 0" class="posts row">
      <Post
        @plan-selected="$emit('plan-selected', plan)"
        v-for="(plan, i) in plans"
        :key="i"
        :plan="plan"
        :guide="guide"
      />
      <Tags :tags="guide.profile.tags" />
    </div>
  </div>
</template>
<script>
import Tags from "./Tags";
import Post from "./Post";
import ShareGuideBooking from "@/mixins/ShareGuideBooking.js";
export default {
  mixins: [ShareGuideBooking],
  data() {
    return {
      posts: [
        {
          name: "Write Something",
          price: "$75",
          session: "/session",

          post1: `Writing is all about grabbing the pen or putting your hands on the keyboard.
                            It is all about getting started. Results will come, the flow will come,
                            once you have started so many times that it become..`,
          post2: ` sit amet, consectetur adipiscing elit. Vel nisi velit vel turpis egestas et, venenatis. Quis consectetur et diam vulputate. Integer duis viverra quis risus suspendisse quam. Sagittis, pretium diam vulputate viverra tellus risus ut enim ac. Quam nulla vulputate feugiat posuere. Volutpat nulla risuselementum.`
        },
        {
          name: "Manage Finance",

          price: "$81",
          session: "/session",

          post1: `Writing is all about grabbing the pen or putting your hands on the keyboard.
                            It is all about getting started. Results will come, the flow will come,
                            once you have started so many times that it become..`,
          post2: ` sit amet, consectetur adipiscing elit. Vel nisi velit vel turpis egestas et, venenatis. Quis consectetur et diam vulputate. Integer duis viverra quis risus suspendisse quam. Sagittis, pretium diam vulputate viverra tellus risus ut enim ac. Quam nulla vulputate feugiat posuere. Volutpat nulla risuselementum.`
        },
        {
          name: "Find Financial Freedom",

          price: "$50",
          session: "/session",

          post1: `Writing is all about grabbing the pen or putting your hands on the keyboard.
                            It is all about getting started. Results will come, the flow will come,
                            once you have started so many times that it become..`,
          post2: ` sit amet, consectetur adipiscing elit. Vel nisi velit vel turpis egestas et, venenatis. Quis consectetur et diam vulputate. Integer duis viverra quis risus suspendisse quam. Sagittis, pretium diam vulputate viverra tellus risus ut enim ac. Quam nulla vulputate feugiat posuere. Volutpat nulla risuselementum.`
        }
      ]
    };
  },
  props: {
    guide: {
      type: Object
    }
  },
  computed: {
    plans() {
      if (this.guide.profile && this.guide.profile.plans) {
        return this.guide.profile.plans.filter(plan => {
          return plan._deleted_at == null && plan.isActive == true;
        });
      }
      return [];
    }
  },
  components: {
    Tags,
    Post
  }
};
</script>

<style lang="scss" scoped>
.posts {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 10px;
  font-family: "Nunito", sans-serif;
}
.posts {
  margin-top: -114px;
}

.social-sharing {
  width: 176px;
  display: grid;
  grid-template-columns: 32px 32px 32px 32px;
  grid-column-gap: 16px;
  .ico {
    cursor: pointer;
    background: rgba(179, 194, 203, 0.1);
    height: 32px;
    width: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      background: rgba(179, 194, 203, 0.3);
    }
  }
}

@media (max-width: 1100px) {
  .posts {
    margin-top: 10px;
  }
}
</style>
